function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M22.75,3H16V.75A.76.76,0,0,0,15.25,0h-8A.76.76,0,0,0,6.5.75V3H.75a.75.75,0,0,0,0,1.5H2.5V23.75a.76.76,0,0,0,.75.75h16a.76.76,0,0,0,.75-.75V4.5h2.75a.75.75,0,0,0,0-1.5ZM8,1.5h6.5V3H8ZM18.5,23H4V4.5H18.5ZM8,7.25v12a.75.75,0,0,1-1.5,0v-12a.75.75,0,0,1,1.5,0Zm4,0v12a.75.75,0,0,1-1.5,0v-12a.75.75,0,0,1,1.5,0Zm3.25-.75a.76.76,0,0,1,.75.75v12a.75.75,0,0,1-1.5,0v-12A.76.76,0,0,1,15.25,6.5Z"
})));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.5 24.5",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.bd8b5638.svg";
export { ForwardRef as ReactComponent };